import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/languages/[language]/LanguagePageClient.tsx");
